import { configureStore } from '@reduxjs/toolkit';
import modalsReducer from './redux-slices/modals.js';


export default configureStore({
    reducer: {
        modals: modalsReducer,
    },
})